import {
  ADD_CONTRACT_FILE,
  ADD_CONTRACT_FILE_SUCCESS,
  ADD_CONTRACT_FILE_FAILURE,
} from 'store/addContractFile/addContractFileAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const addContractFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CONTRACT_FILE:
      return { ...state, loading: true };
    case ADD_CONTRACT_FILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADD_CONTRACT_FILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default addContractFileReducer;
